import Settings from './Settings';
import SettingsBillingForm from './SettingsBillingForm';
import SettingsPasswordForm from './SettingsPasswordForm';
import SettingsPersonalForm from './SettingsPersonalForm';
import SettingsLoginForm from './SettingsLoginForm';

export { SettingsBillingForm, SettingsPasswordForm, SettingsPersonalForm, SettingsLoginForm };

export default Settings;
